var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsesoria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 93.385,
    viewBox: "0 0 100 93.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18945",
    "data-name": "Group 18945",
    transform: "translate(1177 22340)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7718",
    "data-name": "Path 7718",
    className: "cls-1",
    d: "M45.859,41.069a16.488,16.488,0,0,0,4.239-11A16.667,16.667,0,1,0,21,41.069c-6.777,5.576-9.84,12.741-10.9,25.656,0,5.614,0,11.89,7.227,13.116L20.2,94.2c1.9,7.614,7.1,12.528,13.241,12.528s11.328-4.914,13.266-12.678l2.838-14.2c7.227-1.238,7.227-7.539,7.214-13.391-1.05-12.641-4.126-19.8-10.9-25.381ZM33.431,20.052a10,10,0,1,1-10,10,10.016,10.016,0,0,1,10-10ZM46.759,73.39A3.323,3.323,0,0,0,43.5,76.066L40.2,92.582c-1.138,4.539-3.788,7.477-6.764,7.477S27.8,97.121,26.7,92.732L23.366,76.066A3.333,3.333,0,0,0,20.1,73.39q-3.338,0-3.351-6.389c1.05-12.541,4-17.2,8.765-21.005a3.338,3.338,0,0,0,.588-.6c.075-.1.163-.2.238-.3a15.988,15.988,0,0,0,2.088.788l2.788,4.189L26.779,61.187l6.664,8.89,6.664-8.89L35.669,50.072l2.788-4.189a17.469,17.469,0,0,0,2.088-.788c.075.1.163.213.238.313a2.967,2.967,0,0,0,.588.6c4.751,3.8,7.714,8.465,8.752,20.73q0,6.664-3.338,6.664Z",
    transform: "translate(-1187.1 -22353.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7719",
    "data-name": "Path 7719",
    className: "cls-1",
    d: "M73.423,63.385c.163,0,.288-.075.45-.088a13.328,13.328,0,1,0,0-6.477,2.607,2.607,0,0,0-.45-.088H66.759V30.064h6.664c.163,0,.288-.075.45-.088a13.328,13.328,0,1,0,0-6.477,2.607,2.607,0,0,0-.45-.088h-10a3.338,3.338,0,0,0-3.338,3.338V56.758H53.418a3.338,3.338,0,1,0,0,6.677h6.664V93.443a3.338,3.338,0,0,0,3.338,3.338h10c.163,0,.288-.075.45-.088a13.328,13.328,0,1,0,0-6.477,2.607,2.607,0,0,0-.45-.088H66.759V63.46h6.664Zm13.328-10a6.664,6.664,0,1,1-6.664,6.664,6.67,6.67,0,0,1,6.664-6.664Zm0-33.333a6.664,6.664,0,1,1-6.664,6.664A6.67,6.67,0,0,1,86.752,20.049Zm0,66.679a6.664,6.664,0,1,1-6.664,6.664A6.67,6.67,0,0,1,86.752,86.728Z",
    transform: "translate(-1177.092 -22353.398)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsesoria);
export default __webpack_public_path__ + "static/media/asesoria.5e9ed9fa98ecf69422d1eb02664ae0cf.svg";
export { ForwardRef as ReactComponent };